import { isMobile } from '../../utils/device-utils';

const MAX_CONTENTS_LIMIT = 50;

export const getMaxContents = (htmlProps) => {
  if (htmlProps.maxContentsMobile) {
    return isMobile() ? parseInt(htmlProps.maxContentsMobile, 10) : parseInt(htmlProps.maxContentsDesktop, 10);
  } else {
    return parseInt(htmlProps.maxContents, 10) || MAX_CONTENTS_LIMIT;
  }
};

export const getMaxVideoContents = (htmlProps) =>
  isMobile()
    ? parseInt(htmlProps.maxVideoContentsMobile, 10) || MAX_CONTENTS_LIMIT
    : parseInt(htmlProps.maxVideoContentsDesktop, 10) || MAX_CONTENTS_LIMIT;
